<template>
  <div class="section__wrap">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'FormSectionWrap',
  mounted() {
    // 處理.labeltxts class內加了button後會跑版的問題
    // const elList = this.$el.querySelectorAll('.labeltxts > button');
    // elList.forEach((el) => {
    //   const elParent = el.parentElement.parentElement;
    //   const elParentPrev = elParent.previouselementsibling;
    //   const elParentNext = elParent.nextElementSibling;
    //   if (elParentPrev !== null && elParentPrev !== undefined) {
    //     elParentPrev.querySelector('.labeltxts').style.minHeight = '48px';
    //   }

    //   if (elParentNext !== null && elParentNext !== undefined) {
    //     elParentNext.querySelector('.labeltxts').style.minHeight = '48px';
    //   }
    // });
  },
};
</script>

<style lang="scss" scoped>
::v-deep.section {
  &__wrap {
    border: 1px solid $secondary;
    background-color: $secondaryGray;

    .formBox-contain-group {
      border-left: 1px solid $secondary;
      border-top: 1px solid $secondary;
      border-bottom: unset;
      border-right: unset;
      margin:-1px 0 0 -1px;
    }
  }
}
</style>
